import React from 'react'
import {IIncomeDocument} from '../IncomeDocumentDetailPage'
import {Text, View} from '@react-pdf/renderer'
import moment from 'moment/moment'
import {IncomeDocumentTypes} from '../../../constants/Common'
import {isEmpty} from 'lodash'
import {fontWeight} from 'html2canvas/dist/types/css/property-descriptors/font-weight'

interface IPrintSignatureSection {
  document: IIncomeDocument
  styles?: {[key: string]: any}
}

const PrintSignatureSection: React.FC<IPrintSignatureSection> = (props) => {
  const { document, styles } = props
  const isRequestPurchaseOrder = document.type === IncomeDocumentTypes.EXPENSE_REQUEST_PURCHASE_ORDER

  const _renderSignatureBox = (title: string, name?: string, date?: string, isStamp?:boolean) => {
    return (
      <View style={{flex: 1, textAlign: 'center'}}>
        <Text style={isRequestPurchaseOrder ? {fontWeight: 'bold'} : {}}>{title}</Text>
        <View style={{marginTop: isRequestPurchaseOrder ? 0 :'30px', lineHeight: '13px'}}>
          {!isStamp && <Text style={{color: '#616161'}}>{'----------------------'}</Text>}
          {!isEmpty(name)
            ? <Text style={{fontWeight: isRequestPurchaseOrder ? '' : 'bold'}}>{name}</Text>
            : <Text>{' '}</Text>
          }
          {(date && date !== 'Invalid date') && <Text>{date}</Text>}
        </View>
      </View>
    )
  }

  const _renderSignatureExpense = () => {
    return (
      <>
        {_renderSignatureBox('ผู้ออกเอกสาร (ผู้ซื้อ)', document?.actionBy?.fullName, moment().format('DD/MM/YYYY'))}
        {_renderSignatureBox('ผู้อนุมัติเอกสาร (ผู้ซื้อ)', document?.approver?.fullName, moment(document?.approvalDate).format('DD/MM/YYYY'))}
        {_renderSignatureBox('ตราประทับ (ผู้ซื้อ)', undefined, undefined, true)}
        {_renderSignatureBox('ผู้รับเอกสาร (ผู้ขาย)', document.labCompany.name)}
        {_renderSignatureBox('ตราประทับ (ผู้ขาย)', undefined, undefined, true)}
      </>
    )
  }

  const _renderSignatureExpenseRequestPurchase = () => {
    return (
      <>
        {_renderSignatureBox('ผู้ขอซื้อ', document?.actionBy?.fullName || 'ไม่พบข้อมูลผู้ขอซื้อ')}
        {_renderSignatureBox('อนุมัติโดย', document?.approver?.fullName || 'ไม่พบข้อมูลผู้อนุมัติ')}
      </>
    )
  }

  const _renderSignatureQuotation = () => {
    return (
      <>
        {_renderSignatureBox('ผู้เสนอราคา', document?.seller?.fullName, moment().format('DD/MM/YYYY'))}
        {_renderSignatureBox('ผู้อนุมัติ', document?.approver?.fullName, moment(document?.approvalDate).format('DD/MM/YYYY'))}
        {_renderSignatureBox('ผู้อนุมัติซื้อ', document.labCompany.name)}
      </>
    )
  }

  const _renderSignatureBillingNote = () => {
    return (
      <View style={{flex: 1}}>
        <Text style={{width: '50%', marginLeft: 'auto', textAlign: 'center'}}>{'ในนามบริษัท แอลดีซี เด็นทัล จำกัด (มหาชน)'}</Text>
        <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '8px', padding: '8px 0'}}>
          {_renderSignatureBox('ผู้รับวางบิล', document?.labCompany?.name, moment().format('DD/MM/YYYY'))}
          {_renderSignatureBox('ผู้วางบิล', document?.seller?.fullName, moment().format('DD/MM/YYYY'))}
        </View>
      </View>
    )
  }

  const _renderSignatureReceiptAndDeposit = () => {
    return (
      <View style={{flex: 1}}>
        <Text style={{width: '50%', marginLeft: 'auto', textAlign: 'center'}}>{'ในนามบริษัท แอลดีซี เด็นทัล จำกัด (มหาชน)'}</Text>
        <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '8px', padding: '8px 0'}}>
          {_renderSignatureBox('ผู้รับเงิน', document?.seller?.fullName, moment().format('DD/MM/YYYY'))}
          {_renderSignatureBox('ผู้มีอำนาจลงนาม', document?.approver?.fullName, moment().format('DD/MM/YYYY'))}
        </View>
      </View>
    )
  }

  const _renderSignatureInvoiceAndDebit = () => {
    return (
      <View style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
        <View style={{display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'flex-end'}}>
          <View style={{width: '32%', textAlign: 'center'}}>
            <Text>ได้รับสินค้าตามรายการข้างต้นนี้ได้ถูกต้อง และอยู่ในสภาพเรียบร้อยทุกประการ</Text>
          </View>
          <View style={{width: '1px', height: '100%', backgroundColor: '#B7B7B7'}} />
          <View style={{width: '68%', textAlign: 'right'}}>
            <Text>ในนามบริษัท แอลดีซี เด็นทัล จำกัด (มหาชน)</Text>
          </View>
        </View>
        <View style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
          <View style={{width: '32%'}}>
            {_renderSignatureBox('ผู้รับสินค้า/ผู้รับบริการ', document?.labCompany?.name, moment().format('DD/MM/YYYY'))}
          </View>
          <View style={{width: '1px', height: '100%', backgroundColor: '#B7B7B7'}} />
          <View style={{display: 'flex', flexDirection: 'row', width: '68%', textAlign: 'right'}}>
            {_renderSignatureBox('ผู้ส่งสินค้า', '', moment().format('DD/MM/YYYY'))}
            {_renderSignatureBox('ผู้จัดทำ', document?.seller?.fullName, moment().format('DD/MM/YYYY'))}
            {_renderSignatureBox('ผู้มีอำนาจลงนาม', document?.approver?.fullName, moment().format('DD/MM/YYYY'))}
          </View>
        </View>
      </View>
    )
  }

  const _renderSignatureCreditAndTax = () => {
    return (
      <View style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
        <Text style={{marginLeft: 'auto'}}>ในนามบริษัท แอลดีซี เด็นทัล จำกัด (มหาชน)</Text>
        <View style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
          <View style={{width: '32%'}}>
            {_renderSignatureBox('ผู้ส่งคืนสินค้า/ผู้รับบริการ', document?.labCompany?.name, moment().format('DD/MM/YYYY'))}
          </View>
          <View style={{width: '1px', height: '100%', backgroundColor: '#B7B7B7'}} />
          <View style={{display: 'flex', flexDirection: 'row', width: '68%', textAlign: 'right'}}>
            {_renderSignatureBox('ผู้รับสินค้า', '', moment().format('DD/MM/YYYY'))}
            {_renderSignatureBox('ผู้จัดทำ', document?.seller?.fullName, moment().format('DD/MM/YYYY'))}
            {_renderSignatureBox('ผู้มีอำนาจลงนาม', document?.approver?.fullName, moment().format('DD/MM/YYYY'))}
          </View>
        </View>
      </View>
    )
  }

  const _renderSection = () => {
    switch (document.type) {
      case IncomeDocumentTypes.EXPENSE_REQUEST_PURCHASE_ORDER:
        return _renderSignatureExpenseRequestPurchase()
      case IncomeDocumentTypes.EXPENSE_PURCHASE_INVENTORY_RECORD:
      case IncomeDocumentTypes.EXPENSE_EXPENSE_RECORD:
      // เอกสารฝั่งรายจ่ายอื่นเดิมตกไป default ไม่มีช่องลายเซ็นเลย (30 ก.ย. 2569)
      case IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE:
      case IncomeDocumentTypes.EXPENSE_PURCHASE_DEBIT_NOTE:
      case IncomeDocumentTypes.EXPENSE_DEPOSIT_PAYMENT:
      case IncomeDocumentTypes.EXPENSE_PURCHASE_TAX_INVOICE:
      case IncomeDocumentTypes.EXPENSE_PURCHASE_ASSET_ORDER:
        return _renderSignatureExpense()
      case IncomeDocumentTypes.QUOTATION:
        return _renderSignatureQuotation()
      case IncomeDocumentTypes.BILLING:
        return _renderSignatureBillingNote()
      case IncomeDocumentTypes.DEPOSIT:
      case IncomeDocumentTypes.RECEIPT:
        return _renderSignatureReceiptAndDeposit()
      case IncomeDocumentTypes.INVOICE:
      case IncomeDocumentTypes.DEBIT:
        return _renderSignatureInvoiceAndDebit()
      case IncomeDocumentTypes.CREDIT:
        return _renderSignatureCreditAndTax()
      default:
        return <></>
    }
  }

  return (
    <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '8px', borderTop: '1px solid #bfbfbf', padding: '8px 0', ...styles}}>
      {!isRequestPurchaseOrder && (
        <View style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px', minWidth: '50px'}}>
          <Text style={{fontFamily: 'FontAwesome', fontSize: 9}}>{'\uf5b7'}</Text>
          <Text style={{fontWeight: 'bold'}}>{'รับรอง'}</Text>
        </View>
      )}

      {_renderSection()}
    </View>
  )
}

export default PrintSignatureSection
